import { render, staticRenderFns } from "./PlatformReceivables.vue?vue&type=template&id=5f9328fa&scoped=true&"
import script from "./PlatformReceivables.vue?vue&type=script&lang=js&"
export * from "./PlatformReceivables.vue?vue&type=script&lang=js&"
import style0 from "./PlatformReceivables.vue?vue&type=style&index=0&id=5f9328fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9328fa",
  null
  
)

export default component.exports